// extracted by mini-css-extract-plugin
module.exports = {"expense":"ExpenseInfoBox-styles-module--expense--3PMqg"};